import { StaticTooltipHost } from "@vintecc/components";
import { useState } from "react";
import { NetworkLogEntry } from "../../types/network.type";
import { DebugJsonPanel } from "./DebugJsonPanel";

interface DebugRequestEntryProps {
  log: NetworkLogEntry;
}

export const DebugRequestEntry: React.FC<DebugRequestEntryProps> = ({ log }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasDetails = log.body != null || log.response != null;

  return (
    <div role="rowgroup" className={["bg-grey-100 even:bg-white rounded ", isExpanded ? "bg-grey-200" : "bg-grey-100 even:bg-white"].join(" ")}>
      <button
        type="button"
        role="row"
        aria-expanded={hasDetails ? isExpanded : undefined}
        onClick={() => hasDetails && setIsExpanded((prev) => !prev)}
        className={["w-full flex gap-2 justify-between p-2 rounded text-start", hasDetails ? "cursor-pointer hover:bg-grey-200" : ""].join(" ")}
      >
        <div role="cell">
          <strong>{log.method}</strong>
        </div>
        <div role="cell" className={log.status && log.status >= 200 && log.status < 300 ? "text-green-500" : "text-red-500"}>
          <strong>{log.status}</strong>
        </div>
        <div role="cell" className="flex-1">
          {log.endpoint}
        </div>
        <StaticTooltipHost tooltip={log.timestamp.toLocaleTimeString()}>
          <div role="cell" className="text-end">
            {log.duration && log.duration >= 500 && "🐌"}
            {log.duration}ms
          </div>
        </StaticTooltipHost>
        {hasDetails && (
          <div role="cell" aria-hidden className="text-grey-400">
            {isExpanded ? "▲" : "▼"}
          </div>
        )}
      </button>

      {isExpanded && (
        <div role="row" className="rounded-t-none rounded-b p-2 flex flex-col gap-2">
          {log.body != null && <DebugJsonPanel label="Request body" data={log.body} />}
          {log.response != null && <DebugJsonPanel label="Response" data={log.response} />}
        </div>
      )}
    </div>
  );
};
